import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import RootLayout from "../layout";
import httpService from "../../services/http.service";
import { getCMSApiRoute } from "../../utils/api.utils";
import SpitialProfileFavourties from "../../components/profile/favourites";

const checkAuth = () => localStorage.getItem("webTvUserToken");

const ProfileFavourtiesPage = () => {
  const auth = checkAuth();
  const navigate = useNavigate();

  if (!auth) {
    navigate("/login");
  }

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  async function getData() {
    try {
      const response = await httpService.get(getCMSApiRoute("action/bookmark"));

      const { data } = response.data;
      return data;
    } catch (err) {
      console.log(err);
      return {};
    }
  }

  useEffect(() => {
    getData().then((data) => {
      setData(data);
      setLoading(false);
    });
  }, []);

  return (
    <RootLayout>
      <SpitialProfileFavourties data={data} loading={loading} />
    </RootLayout>
  );
};
export default ProfileFavourtiesPage;
